import React from "react";

export const Aligned = (props: React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>) => (
  <div
    style={{ display: "flex", justifyContent: "start", alignItems: "center", flexWrap: "wrap", ...(props.style || {}) }}
    className={props.className}
    id={props.id}
  >
    {props.children}
  </div>
);
